<!--
 * @Author: 陈红伟 chenhw2019@gmail.com
 * @Date: 2024-06-06 13:47:10
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-06-06 13:47:55
 * @FilePath: /partner.chaoyongtuan.com/src/views/settings/message/tableCells/messgaeName.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="color-gy-9 flex-row flex-align-center">
		{{ row.message_name }}
		<rdTag v-if="row.isException" class="ml-6" tagType="warning">异常提醒</rdTag>
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
	data() {
		return {};
	},
	components: {},
	methods: {},
};
</script>